module.exports = __webpack_public_path__ + "img/splash_screen.f5918c1e.png";